import {
    Close
} from '@mui/icons-material';
import {
    Box, Container,
    IconButton,
    Modal,
    Stack, Typography
} from '@mui/material';
import wp1 from '../../assets/others/wp1.png';
import wp2 from '../../assets/others/wp2.png';

export default function CarbonFootprintInfo({ open, handleClose, content }) {
    return (
        <Modal
        open={open}
        onClose={handleClose}
        >
        <Container maxWidth={'xs'} className='modal-container' sx={{ maxHeight: '70vh', padding: 3 }}>
        <Box sx={{ flex: 'auto' }} className='spread-y'>
            <Stack spacing={1}>
                <Box className='spread-x' sx={{ alignItems: 'start' }}>
                    <Typography variant="h6">
                        {content?.fulllabel || 'Want to learn more?'}
                    </Typography>
                    <IconButton onClick={handleClose}>
                        <Close />
                    </IconButton>
                </Box>
                <Typography variant="body2">
                    {content?.valuelabel || 
                        <>The carbon footprint estimations in this app are computed using the algorithm detailed in our SGFIN Whitepapers "Consumption Carbon Footprint: Country Level Framework", and "Consumption Carbon Footprint: Singapore Case Study", soon to be published on our <a href="https://sgfin.nus.edu.sg/publications/whitepapers/" target='_blank' rel="noopener noreferrer">SGFIN website.</a></>
                    }
                </Typography>

                {content===null &&
                <>
                <img src={wp1} alt="whitepaper 1" />
                <img src={wp2} alt="whitepaper 2" />
                </>
                }

                <Typography variant="caption">
                    {content?.addtinfo}
                </Typography>
                { content?.source &&
                    <Typography variant="caption">
                        Source: <a style={{ color: 'var(--pri-purple)'}} href={content?.sourcelink}>{content?.source}</a>
                    </Typography>
                }
            </Stack>
        </Box>
        </Container>
        </Modal>
    )   
}